import { apiRequest } from './api';
import type { ApiResponse } from '../types';

export interface SandboxInvestor {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  status: 'pending' | 'accepted';
  invitedAt: string;
}

export interface SandboxAcceptInfo {
  tenantId: string;
  tenantName: string;
  primaryColor: string;
  secondaryColor: string;
  logoUrl: string | null;
  email: string;
  tokenValid: boolean;
}

export const sandboxOnboardingApi = {
  checkSlug: (slug: string) =>
    apiRequest<{ available: boolean }>('GET', `/sandbox/onboarding/slug-check?slug=${encodeURIComponent(slug)}`),

  launch: (payload: {
    companyName: string;
    slug: string;
    primaryColor: string;
    accentColor: string;
    fontFamily?: string;
    logoS3Key?: string;
    logoS3Bucket?: string;
    investorEmails: string[];
    adminEmails: string[];
  }) =>
    apiRequest<{ sandboxTenantId: string; trialExpiresAt: string }>('POST', '/sandbox/onboarding/launch', payload),

  getBrandingUploadUrl: (payload: { filename: string; mimeType: string }) =>
    apiRequest<{ uploadUrl: string; s3Key: string; s3Bucket: string }>('POST', '/sandbox/onboarding/branding/upload-url', payload),

  getInvestors: () =>
    apiRequest<SandboxInvestor[]>('GET', '/sandbox/onboarding/investors'),

  resendInvite: (id: string) =>
    apiRequest<void>('POST', `/sandbox/onboarding/investors/${id}/resend`),

  getAcceptInfo: (token: string) =>
    apiRequest<SandboxAcceptInfo>('GET', `/sandbox/onboarding/accept?token=${encodeURIComponent(token)}`),

  acceptInvite: (payload: {
    token: string;
    firstName: string;
    lastName: string;
    password: string;
  }) => apiRequest<{ token: string; user: Record<string, unknown> }>('POST', '/sandbox/onboarding/accept', payload),
};
